import bizzaboAjax, { getDomainAdjustedPath } from 'bizzaboAjax';
import Cookies from 'js-cookie';
import _ from 'underscore';
import config from 'config';
import { stringify } from 'query-string';
import Q from 'q';
import {ok as assertOk} from 'assert';
import {simpleProfileUrl} from '@bizzabo/linkedin-utils';
import { isBizzaboInternalWebsiteWhiteLabeled } from '@bizzabo/whitelabel-utils';
import axios from 'axios';


export function makeAjaxRequest(url, options) {
    const deferred = Q.defer();
    if (!url) {
        return;
    }
    bizzaboAjax({
        method: options.method || 'GET',
        url,
        data: options.data || {},
        success: (response) => {
            options.success && options.success(response);
            deferred.resolve(response);
        },
        error: (err) => {
            options.error && options.error(err);
            deferred.reject(err);
        }
    });
    return deferred.promise;
}


const getPersonById = function(options) {
    if (!options && (!options.personId || !options.eventId)) {
        options.error && options.error();
        return;
    }
    const url = `/api/v2/community/${options.eventId}/search?userIds=${options.personId}`;
    makeAjaxRequest(url, options);
};

const getMarkerObject = (eventId, markerType, entity, entityId) => ({ eventId, markerType, entity, entityId });

const toggleLead = function(options) {
    const toggleMethod = options.myLead ? 'DELETE' : 'PUT';
    const url = `${config.baseV2Url}/community/${options.eventId}/lead/${options.personId}`;
    options.method = toggleMethod;
    makeAjaxRequest(url, options);
};

const urlGenerator = function(options = {}) {
    let base = `${config.baseV2Url}/community/${options.eventId}/search?`;
    const addParam = function(base, query, name) {
        if (query[name]) {
            base += `${name}=${encodeURIComponent(query[name])}&`;
        }
        return base;
    };
    base = addParam(base, options.search, 'q');
    base = addParam(base, options.search, 'sort');
    base = addParam(base, options.search, 'count');
    base = addParam(base, options.search, 'offset');
    base = addParam(base, options.search, 'filter');

    const attributes = options.search.attributes || [];

    attributes.forEach((item) => {
        base += `${'attribute' + '='}${encodeURIComponent(item.category)}:${encodeURIComponent(item.keyName)}&`;
    });

    return base;
};

const getPersons = function(options) {
    if (!options || !options.eventId || !options.search) {
        options.error && options.error();
        return;
    }
    const url = urlGenerator(options);
    return makeAjaxRequest(url, options);
};

const getLastMessages = function(options) {
    if (!options || !options.eventId) {
        options.error && options.error();
        return;
    }
    const url = `${config.baseV2Url}/messages?last=true&eventId=${options.eventId}`;
    makeAjaxRequest(url, options);
};

const getLoginSettings = function(options) {
    if (!options || !options.eventId) {
        options.error && options.error();
        return;
    }
    const url = `${config.baseV2Url}/userProfile/accounts/${options.accountId}/events/${options.eventId}/login-settings`;
    return makeAjaxRequest(url, options);
};

const getMessagesByPerson = function(options) {
    if (!options || !options.eventId || !options.targetId) {
        options.error && options.error();
        return;
    }
    const url = `${config.baseV2Url}/messages?eventId=${options.eventId}&targetId=${options.targetId}&count=1000`;
    makeAjaxRequest(url, options);
};

const markMessagesAsRead = function(options) {
    if (!options || !(options.ids && options.ids.length > 0)) {
        options.error && options.error();
        return;
    }

    makeAjaxRequest(`${config.baseV2Url}/messages/read`, {
        method: 'PUT',
        data: options.ids,
        success: options.success
    });
};

const validateLinkedInToken = function(options) {

    const baseUrl = `${config.baseV2Url}/userProfile/socialNetwork/linkedin/get?url=`;
    const linkedInUrl = simpleProfileUrl;
    const url = baseUrl + encodeURIComponent(linkedInUrl);
    makeAjaxRequest(url, options);
};

function sendActivities(options = {}) {
    const eventId = options.eventId;
    const entity = options.entity;
    const id = options.id;
    if (!id || !eventId || !entity) {
        options.error && options.error();
        return;
    }

    const now = Date.now();
    const data = {
        userActivities: [{
            activity: 'view',
            entityType: entity,
            entityId: id,
            context: 'web',
            eventId,
            activityTimestamp: now,
            visible: true
        }]
    };
    const url = `${config.baseV2Url}/userProfile/activities?eventId=${eventId}`;

    makeAjaxRequest(url, {
        method: 'POST',
        data,
        success: options.success,
        error: options.error
    });
}


function sendMessage(options = {}) {
    if (!options.targetId || !options.eventId || !options.text) {
        options.error && options.error();
        return;
    }

    const message = {
        target: 'person',
        targetId: options.targetId,
        eventId: options.eventId,
        text: options.text
    };

    makeAjaxRequest(`${config.baseV2Url}/messages`, {
        method: 'POST',
        data: {
            ...message
        },
        success: options.success,
        error: options.error
    });
}

const saveSettings = (options = {}) => makeAjaxRequest(`${config.baseV2Url}/userProfile/userSettings`, {
    method: 'PUT',
    data: {
        ...options.settings
    }
});

const validateEmail = (options = {}) => makeAjaxRequest(`/api/v1/person/~/email/validate?eventId=${options.eventId}`, {
    method: 'POST'
});

const changeEmail = (options = {}) => makeAjaxRequest(`${config.baseV2Url}/userProfile/addEmail?email=${encodeURIComponent(options.emailToChangeTo)}&eventId=${options.eventId}`, {
    method: 'POST'
});

const approveChangeEmail = (options = {}) => {
    const token = options.token;
    const userId = options.userId;
    if (!token || !userId) {
        options.error && options.error();
        return;
    }

    makeAjaxRequest(`${config.baseV2Url}/userProfile/addEmail?token=${token}&userId=${userId}&setAsPrimary=true`, {
        method: 'PUT',
        success: options.success,
        error: options.error
    });
};

const getSessionDays = ({ eventId }) => {
    assertOk(eventId);
    const url = `${getOrigin()}/agenda/events/${eventId}/sessions/days`;
    return makeAjaxRequest(url, {});
};

const getSessions = ({ query, eventId }) => {
    assertOk(eventId);
    const url = `${getOrigin()}/agenda/events/${eventId}/sessions`;
    return makeAjaxRequest(url, {
        method: 'POST',
        data: query
    });
};

const getUserSessions = ({ query, eventId }) => {
    assertOk(eventId);
    const url = `${config.baseV2Url}/agenda/events/${eventId}/userSessions`;
    return makeAjaxRequest(url, {
        method: 'POST',
        data: query
    });
};

const getSessionsMap = ({ query, eventId }) => {
    assertOk(eventId);
    const url = `${getOrigin()}/agenda/events/${eventId}/sessions/mapping`;
    return makeAjaxRequest(url, {
        method: 'POST',
        data: query
    });
};

const getSessionsUserMap = ({ query, eventId }) => {
    assertOk(eventId);
    const url = `${config.baseV2Url}/agenda/events/${eventId}/sessions/userMapping`;
    return makeAjaxRequest(url, {
        method: 'POST',
        data: query
    });
};

const getSession = async({ eventId, sessionId }) => {
    assertOk(eventId);
    assertOk(sessionId);
    const url = `${getOrigin()}/agenda/events/${eventId}/sessions/${sessionId}`;
    return makeAjaxRequest(url, {});
};

const getNextSessions = async() => {
    const url = `${getOrigin()}/agenda/next-sessions`;
    return makeAjaxRequest(url, {});
};


const getRate = async options => {
    const {eventId, sessionId} = options;
    if (!options || !eventId || !sessionId) {
        options.error && options.error();
        return;
    }
    const url = `${config.baseV2Url}/agenda/events/${eventId}/sessions/${sessionId}/rate`;
    return makeAjaxRequest(url, options);
};

const sendRate = async options => {
    const {eventId, sessionId} = options;
    if (!options || !eventId || !sessionId) {
        options.error && options.error();
        return;
    }
    const url = `${config.baseV2Url}/agenda/events/${eventId}/sessions/${sessionId}/rate`;
    return makeAjaxRequest(url, {
        method: 'PUT',
        data: {
            ...options
        }
    });
};

const getSpeakers = ({eventId, query}) => {
    assertOk(eventId);
    return makeAjaxRequest(
        `${getOrigin()}/agenda/events/${eventId}/speakers`,
        {
            data: query
        }
    );
};

const getSpeaker = (options) => {
    if (!options || !options.eventId || !options.speakerId) {
        options.error && options.error();
        return;
    }
    const url = `${config.baseV2Url}/agenda/events/${options.eventId}/speakers/${options.speakerId}`;
    return makeAjaxRequest(url, options);
};


const getRegistrationEnabled = ({eventId}) => {
    assertOk(eventId);
    const url = `${getOrigin()}/agenda/events/${eventId}/sessionRegistration/enabled`;
    return makeAjaxRequest(url, {});
};

const getRegisteredSessionIds = options => {
    let url = `${config.baseV2Url}/agenda/events/${options.eventId}/sessions/registered`;
    if (options && options.personId){
        url += `?personId=${options.personId}`;
    }
    return makeAjaxRequest(url, options);
};

const getMarkers = () => {
    const url = `${config.baseV2Url}/userProfile/markers`;
    return makeAjaxRequest(url, {});
};

const toggleMarker = async(options) => {
    try {
        if (!options || !options.method || !options.data) {
            throw new Error('WRONG_OPTIONS_FOR_MARKER_TOGGLE');
        }
        const error = await makeAjaxRequest(
            `${config.baseV2Url}/userProfile/markers`,
            { method: options.method, data: options.data }
        );

        if (error) {
            throw new Error(JSON.stringify(error));
        }
        return { toggled: true };
    } catch (err) {
        throw err;
    }
};

const getLikesCount = ({ eventId, entity, entityId, error }) => {
    if (!eventId || !entity || !entityId) {
        error && error();
        return;
    }
    const url = `${config.baseV2Url}/userProfile/markers/event/${eventId}/${entity}/like/${entityId}`;
    return makeAjaxRequest(url, {});
};

const getSettings = eventId => {
    if (!eventId) {
        throw new Error('eventId isn\'t provided');
    }
    const url = `${config.baseV2Url}/agenda/events/${eventId}/settings`;
    return makeAjaxRequest(url, {});
};

const sendLoginEmail = async({ eventGroupId, email, eventId, redirectUrl }) => {

    try {
        await makeAjaxRequest(
            `${config.baseV2Url}/userProfile/sendLoginEmail`,
            {
                method: 'POST',
                data: { eventGroupId, email, eventId, redirectUrl }
            }
        );
    } catch (err) {
        throw err;
    }
};


const checkIfHasError = response => {
    if (response && response.error) {
        throw new Error(response.error.message);
    }
    return response;
};

const getPartners = ({eventId}) => {
    assertOk(eventId);
    const url = `${getOrigin()}/organizer/event/${eventId}/partners`;
    return makeAjaxRequest(url, {});
};


// ##### CUSTOM CODE #####

const getCustomCode = ({customCodeUrl}) => {
    if (!customCodeUrl) {
        throw new Error('custom Code Url is missing');
    }
    const url = `/customCode?customCodeUrl=${encodeURIComponent(customCodeUrl)}`;
    return fetch(url, {
        credentials: 'same-origin'
    }).then(res => {
        if (res.status !== 200) {
            return Promise.reject();
        }
        return res.json();
    });
};
// ##### CUSTOM CODE #####

const getUserTickets = (eventId) => {
    try {
        const url = `${config.baseV2Url}/userProfile/tickets?eventId=${eventId}`;
        return makeAjaxRequest(url, {});
    } catch (e) {
        throw new Error('Error in getUserTickets request');
    }
};

const getSessionForRegistrationByTicket = (eventId, ticketId) => {
    const url = `${config.baseV2Url}/agenda/events/${eventId}/sessionRegistrationSettingsByTicketId?ticketId=${ticketId}&platform=web`;
    return makeAjaxRequest(url, {});
};

const getRegisteredSessionByTicket = (eventId, ticketId, personId) => {
    let url = `${config.baseV2Url}/agenda/events/${eventId}/sessions/registered?ticketId=${ticketId}`;
    if (personId){
        url += `&personId=${personId}`;
    }
    return makeAjaxRequest(url, {});
};

const toggleSessionRegistrationStatusPerSession = ({ eventId, sessionId, ticketId, toRegister }) => {
    const url = `${config.baseV2Url}/agenda/events/${eventId}/sessions/${sessionId}/register/${ticketId}`;
    return makeAjaxRequest(url, {
        method: toRegister ? 'PUT' : 'DELETE'
    });
};

const getVirtualSessionEndPoint = ({ sessionId, eventId, shouldSendCheckin = false }) => {
    const url = `${config.baseV2Url}/agenda/events/${eventId}/sessions/${sessionId}/virtualSession?checkIn=${shouldSendCheckin}`;
    return makeAjaxRequest(url, {});
};

const getOrigin = () => !document.location.origin ?
    document.location.protocol + '//' + document.location.hostname + (document.location.port ? ':' + document.location.port: '')
    : document.location.origin;

const verifyToken = async({ event, token }) => {
    const isWl = isBizzaboInternalWebsiteWhiteLabeled(event);
    const path = `/auth/emailAssociatedLogin/verifyToken?token=${token}`;
    const url = isWl ? `https://${event.whitelabelUrl}${path}` : `${config.eventsUrl}${path}`;
    return await fetch(url).then(result => result.json());
};

const decodeToken = token => {
    const user = makeAjaxRequest(`${config.baseV2Url}/userProfile/decode?token=${token}`, {});
    return user;
};

const updateCookies = async({ event, groupId }) => {
    const token = Cookies.get('encodedEmailToken');
    const isWl = isBizzaboInternalWebsiteWhiteLabeled(event);
    const path = `/auth/emailAssociatedLogin/verifyAndSetCookies?token=${token}&eventGroupId=${groupId}`;
    const url = isWl ? `https://${event.whitelabelUrl}${path}` : `${config.eventsUrl}${path}`;
    await fetch(url).then(result => result);
};

const getUser = () => {
    const url = `${config.baseV2Url}/userProfile`;
    const user = makeAjaxRequest(url, {});
    return user;
};

const checkIfInCommunity = (eventId) => {
    const url = `${config.baseV2Url}/community/${eventId}`;
    return makeAjaxRequest(url, {});
};

const getBroadcastRecord = async(eventId, sessionId) => {
    const url = `${config.baseV2Url}/agenda/events/${eventId}/sessions/${sessionId}/virtualSession/recording`;
    return await makeAjaxRequest(url, {});
};

const checkOutVirtualSession = ({ internalWebsiteBaseUrl = '', eventId, sessionId, groupId, async = false }) => {
    assertOk(eventId, 'eventId is missing');
    assertOk(sessionId, 'sessionId is missing');
    const body = { eventId, sessionId };
    const url = `${internalWebsiteBaseUrl}/agenda/session/checkout?eventGroupId=${groupId}`;
    const xhr = new XMLHttpRequest();
    xhr.open('POST', url, async);
    xhr.setRequestHeader('Content-Type', 'application/json; charset=utf-8');
    xhr.setRequestHeader('Feature-Policy', "sync-xhr '*'");
    xhr.send(JSON.stringify(body));
};

const changeAttendeeSessionStatusNode = ({ internalWebsiteBaseUrl = '', groupId, ...data }) => {
    const url = `${internalWebsiteBaseUrl}/agenda/session/attendeeSessionStatus?eventGroupId=${groupId}`;
    return makeAjaxRequest(url, {
        method: 'POST',
        data
    });
};

const changeAttendeeSessionStatusAgenda = ({ internalWebsiteBaseUrl = '', groupId, eventId, sessionId, ...data }) => {
    const url = `${config.baseV2Url}/agenda/events/${eventId}/sessions/${sessionId}/attendeeSessionStatus`;
    return makeAjaxRequest(url, {
        method: 'PUT',
        data
    });
};

const getAgendaMagicLink = ({ eventId }) => {
    assertOk(eventId, 'eventId is missing');
    const url = `${config.baseUrl}/events/${eventId}/magicLink`;
    return makeAjaxRequest(url, {});
};

const cookiesAccessCheck = (eventId) => {
    const url = '/cookiesAccessCheck';
    return fetch(url, {
        credentials: 'same-origin'
    }).then(res => {
        if (res.status !== 200) {
            return Promise.reject();
        }
        return res.json();
    });
};

const checkAccessErrors = (eventId, sessionId) => {
    const url = `${config.baseV2Url}/agenda/events/${eventId}/sessions/${sessionId}/accessAllowance`;
    return makeAjaxRequest(url, {});
};

const logout = () => {
    const url = `${config.baseV2Url}/auth/access-token`;
    return makeAjaxRequest(url, { method: 'DELETE' });
};

const getInteractiveLivestreamAccessResponse = (eventId, sessionId) => {
    const url = `${config.baseV2Url}/agenda/events/${eventId}/sessions/${sessionId}/virtualSession`;
    return makeAjaxRequest(url, { method: 'GET' });
};

const postAttendeeHearbeat = async({accountId, eventId, connectionId}, payload) => {
    const url = (`${config.baseV2Url}/videomgmt/accounts/${accountId}/events/${eventId}/connections/${connectionId}/attendeeHeartBeat`);
    return makeAjaxRequest(url, { method: 'POST', data: payload });
};

const getZoomSessionSignature = async({ accountId, eventId, sessionId, meetingId }) => {
    const url = `${config.baseV2Url}/videomgmt/events/${eventId}/sessions/${sessionId}/zoomMeetings/${meetingId}/token`;
    return makeAjaxRequest(url, { method: 'POST'});
};

const getWalletUrl = async(walletType, accountId, eventId, personTicketId, passkey, myToken) => {
    const url = `${config.baseUrl}/accounts/${accountId}/events/${eventId}/tickets/${personTicketId}/pkpass/${passkey}/presigned-${walletType}-wallet-url?token=${myToken}`;
    try {
        const res = await axios.get(url);
        return res?.data && res?.data.length > 1 ? {hasUrl: true, data: res.data} : {hasUrl: false, status: res.status};
    } catch (error) {
        return {hasUrl: false, status: error.response.status};
    }
};

const getAgendaCustomization = (eventId) => {
    const url = `${config.baseUrl}/events/${eventId}/site/agenda`;
    return makeAjaxRequest(url, { method: 'GET' }).then(({ customizationJson = '{}' }) => {
        const data = JSON.parse(customizationJson);
        return data;
    });
};

export {
    getPersons,
    getPersonById,
    markMessagesAsRead,
    toggleLead,
    getLastMessages,
    getMessagesByPerson,
    validateLinkedInToken,
    sendMessage,
    saveSettings,
    validateEmail,
    sendActivities,
    changeEmail,
    approveChangeEmail,
    getSessionDays,
    getSessions,
    getUserSessions,
    getSessionsMap,
    getSessionsUserMap,
    getSession,
    getRate,
    sendRate,
    getSpeakers,
    getSpeaker,
    getMarkers,
    toggleMarker,
    getLikesCount,
    getSettings,
    sendLoginEmail,
    checkIfHasError,
    getRegistrationEnabled,
    getRegisteredSessionIds,
    getPartners,
    getCustomCode,
    getUserTickets,
    getSessionForRegistrationByTicket,
    getRegisteredSessionByTicket,
    toggleSessionRegistrationStatusPerSession,
    getVirtualSessionEndPoint,
    verifyToken,
    decodeToken,
    updateCookies,
    getUser,
    checkIfInCommunity,
    getBroadcastRecord,
    getNextSessions,
    checkOutVirtualSession,
    getAgendaMagicLink,
    cookiesAccessCheck,
    checkAccessErrors,
    getLoginSettings,
    changeAttendeeSessionStatusNode,
    changeAttendeeSessionStatusAgenda,
    getInteractiveLivestreamAccessResponse,
    postAttendeeHearbeat,
    getZoomSessionSignature,
    getWalletUrl,
    getAgendaCustomization
};
